import PropTypes from 'prop-types';
import React from 'react';

import { ModelYear, PurchaseMethods, Quote } from '@sm360/widget-commons-vehicle';

import AccessoryImage from 'build-and-quote/components/OptionsAccessories/OptionAccessory/component/AccessoryImage/AccessoryImage.jsx';
import AccessoryAmount from 'build-and-quote/components/OptionsAccessories/OptionAccessory/component/AccessoryAmount/AccessoryAmount.jsx';
import AccessoryDetails from 'build-and-quote/components/OptionsAccessories/OptionAccessory/component/AccessoryDetails/AccessoryDetails.jsx';

import OPTION_CATEGORY from 'build-and-quote/constants/optionCategory.js';

import 'build-and-quote/components/OptionsAccessories/OptionsAccessories.scss';

class OptionAccessory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            detailsDisplay: false,
            isHover: false,
        };
        this.showAccessoryDetails = this.showAccessoryDetails.bind(this);
        this.focusInBuildButton = this.focusInBuildButton.bind(this);
        this.focusOutBuildButton = this.focusOutBuildButton.bind(this);
    }

    focusInBuildButton() {
        this.setState({
            isHover: true,
        });
    }
    focusOutBuildButton() {
        this.setState({
            isHover: false,
        });
    }

    showAccessoryDetails() {
        this.setState((prevState) => {
            return { detailsDisplay: !prevState.detailsDisplay };
        });
    }

    render() {
        const {
            isLease,
            isReadOnly,
            selectedFinanceTerm,
            paymentFrequencyLabel,
            taxesFactor,
            optionCategory,
            option,
            selectOption,
            modelYear,
            setAnalyticsValue,
        } = this.props;

        const optionShowDetails = this.state.detailsDisplay ? 'is-flipped' : '';

        const wrapperClass = [`accessory_wrapper single ${optionShowDetails}`];
        if (isReadOnly) {
            wrapperClass.push('is-inventory');
        }
        if (this.state.isHover) {
            wrapperClass.push('is-hover');
        }
        if (option.isConfigurationOption) {
            wrapperClass.push('is-configuration');
        } else if (option.selected) {
            wrapperClass.push('is-selected');
        }

        return (
            <div
                className={wrapperClass.join(' ')}
                onMouseOver={this.focusInBuildButton}
                onFocus={this.focusInBuildButton}
                onMouseOut={this.focusOutBuildButton}
                onBlur={this.focusOutBuildButton}
            >
                {optionCategory.id === OPTION_CATEGORY.ACCESSORIES && (
                    <AccessoryImage option={option} showAccessoryDetails={this.showAccessoryDetails} />
                )}

                <AccessoryAmount
                    key={option.selectionCode}
                    isLease={isLease}
                    isParentHover={this.state.isHover}
                    selectedFinanceTerm={selectedFinanceTerm}
                    paymentFrequencyLabel={paymentFrequencyLabel}
                    taxesFactor={taxesFactor}
                    optionCategory={optionCategory}
                    option={option}
                    optionItems={optionCategory.getItemsPackageContent(option.selectionCode)}
                    selectOption={selectOption}
                    modelYear={modelYear}
                    setAnalyticsValue={setAnalyticsValue}
                />

                <AccessoryDetails
                    option={option}
                    optionItems={optionCategory.getItemsPackageContent(option.selectionCode)}
                    showAccessoryDetails={this.showAccessoryDetails}
                />
            </div>
        );
    }
}

OptionAccessory.propTypes = {
    isLease: PropTypes.bool.isRequired,
    isReadOnly: PropTypes.bool.isRequired,
    option: PropTypes.instanceOf(ModelYear.OptionModel).isRequired,
    optionCategory: PropTypes.instanceOf(Quote.QuoteItemCategoryModel).isRequired,
    paymentFrequencyLabel: PropTypes.string.isRequired,
    selectedFinanceTerm: PropTypes.instanceOf(PurchaseMethods.TermModel).isRequired,
    selectOption: PropTypes.func.isRequired,
    taxesFactor: PropTypes.number.isRequired,
    modelYear: PropTypes.instanceOf(ModelYear.ModelYearModel).isRequired,
};

OptionAccessory.displayName = 'OptionAccessory';

export default OptionAccessory;
